<template>
  <div>
    <a-card :bordered="false">
      <div slot="title">我的关注</div>

      <!-- 查询区域 -->
      <div class="search-area">
        <a-form layout="inline">
          <a-form-item label="项目名称">
            <a-input placeholder="请输入项目名称" style="width: 250px" />
          </a-form-item>
          <a-button type="primary" style="margin-top: 4px;">搜索</a-button>
          <a-button style="margin-left: 10px;">清空</a-button>
        </a-form>
      </div>

      <!-- 表格区域 -->
      <a-table
        :columns="columns"
        :data-source="data"
        rowKey="id"
        :pagination="{ pageSize: 10, total: data.length }"
        :scroll="{ x: 1000 }"
        locale="{ emptyText: '暂无数据' }"
      >
        <template slot="operation">
          <a style="color: #ff4d4f; margin-right: 8px;">取消关注</a>
          <a style="color: #1890ff;">查看</a>
        </template>
      </a-table>
    </a-card>
  </div>
</template>


<script>
export default {
  data() {
    return {
      columns: [
        { title: '项目名称', dataIndex: 'projectName', key: 'projectName', width: 250 },
        { title: '项目编号', dataIndex: 'projectCode', key: 'projectCode', width: 180 },
        { title: '项目分类', dataIndex: 'projectCategory', key: 'projectCategory', width: 150 },
        { title: '关注时间', dataIndex: 'followTime', key: 'followTime', width: 180 },
        { title: '操作', key: 'operation', scopedSlots: { customRender: 'operation' }, width: 180, fixed: 'right' }
      ],
      data: [] // 当前暂无关注记录
    };
  }
};

</script>

<style scoped>
.my-lease {
  background-color: #fff;
  padding: 20px;
}

.search-area {
  margin-bottom: 20px;
}

a-form-item {
  margin-bottom: 15px;
}

/* 关键部分：修复输入框宽度异常 */
.search-area /deep/ .ant-input{
  width: 100% !important;
  height: 32px !important;
  padding: 4px 11px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}
</style>